<template>
  <material-card
    v-if="selectedCompany"
    ref="companyInvoiceDetails"
    :color="companyInvoicesColor"
    full-header
  >
    <template #heading>
      <div class="pl-4 pr-4 pt-1 pb-1 white--text">
        <div class="text-h3 font-weight-light">
          <v-col>
            <v-row>
              {{ selectedCompany }}
              <v-spacer />
              <div class="mt-1 pl-4 text-h5">
                {{ selectedCompanyId }}
              </div>

              <v-divider
                class="ml-4 mr-4"
                vertical
              />

              <v-btn
                color="white"
                icon
                small
                @click="companyInvoiceDetailsButtonClicked"
              >
                <v-icon>
                  mdi-axis-arrow
                </v-icon>
              </v-btn>
            </v-row>
          </v-col>
        </div>
      </div>
    </template>
    <v-row>
      <v-card-text>
        <v-data-table
          hide-default-footer
          disable-pagination
          :headers="agingReportGridHeaders"
          :items="selectedCompanyInfo"
          class="elevation-1"
        >
          <template v-slot:item.totalAmount="{ item }">
            {{ formatCurrencyBasic(item.totalAmount) }}
          </template>
          <template v-slot:item.totalBalance="{ item }">
            {{ formatCurrencyBasic(item.totalBalance) }}
          </template>
          <template v-slot:item.totalDays31_60="{ item }">
            {{ formatCurrencyBasic(item.totalDays31_60) }}
          </template>
          <template v-slot:item.totalDays61_90="{ item }">
            {{ formatCurrencyBasic(item.totalDays61_90) }}
          </template>
          <template v-slot:item.totalDays91_120="{ item }">
            {{ formatCurrencyBasic(item.totalDays91_120) }}
          </template>
          <template v-slot:item.totalDaysOver120="{ item }">
            {{ formatCurrencyBasic(item.totalDaysOver120) }}
          </template>
        </v-data-table>
        <v-divider
          class="mb-2 mt-2"
          :color="companyInvoicesColor"
        />
        <v-data-table
          :headers="companyInvoicesGridHeaders"
          :items="companyInvoiceItems"
          :items-per-page="10"
          class="elevation-1"
        >
          <template v-slot:item.invoiceDate="{ item }">
            {{ formatDate(item.invoiceDate) }}
          </template>
          <template v-slot:item.invoiceBalance="{ item }">
            {{ formatCurrencyBasic(item.invoiceBalance) }}
          </template>
          <template v-slot:item.invoiceAmount="{ item }">
            {{ formatCurrencyBasic(item.invoiceAmount) }}
          </template>
          <template v-slot:item.within10days="{ item }">
            <div
              v-if="item.within10days === true"
              class="yellow--text"
              style="font-size:32px;"
            >
              {{ checkedmark }}
            </div>
            <div v-else>
              {{ uncheckedmark }}
            </div>
          </template>
          <template v-slot:item.days31_60="{ item }">
            <div
              v-if="item.days31_60 > 0"
              class="red--text"
              style="font-size:32px;"
            >
              {{ checkedmark }}
            </div>
            <div v-else>
              {{ uncheckedmark }}
            </div>
          </template>
          <template v-slot:item.days61_90="{ item }">
            <div
              v-if="item.days61_90 > 0"
              class="red--text"
              style="font-size:32px;"
            >
              {{ checkedmark }}
            </div>
            <div v-else>
              {{ uncheckedmark }}
            </div>
          </template>
          <template v-slot:item.days91_120="{ item }">
            <div
              v-if="item.days91_120 > 0"
              class="red--text"
              style="font-size:32px;"
            >
              {{ checkedmark }}
            </div>
            <div v-else>
              {{ uncheckedmark }}
            </div>
          </template>
          <template v-slot:item.late120days="{ item }">
            <div
              v-if="item.late120days === true"
              class="red--text"
              style="font-size:32px;"
            >
              {{ checkedmark }}
            </div>
            <div v-else>
              {{ uncheckedmark }}
            </div>
          </template>
          <template v-slot:item.daysOver120="{ item }">
            <div
              v-if="item.daysOver120 > 0"
              class="red--text"
              style="font-size:32px;"
            >
              {{ checkedmark }}
            </div>
            <div v-else>
              {{ uncheckedmark }}
            </div>
          </template>
        </v-data-table>
      </v-card-text>
    </v-row>
  </material-card>
</template>
<script>
  import {
    formatDate,
    formatNumber,
    formatCurrency,
    formatPercentage,
    formatCurrencyBasic,
  } from '@/util/formatters.js'
  import _ from 'lodash'
  import { companyInvoicesGridHeaders, agingReportGridHeaders } from '@/util/gridHeaders'
  import MaterialCard from '@/components/MaterialCard.vue'

  export default {
    name: 'AgingDetailsView',
    components: { MaterialCard },
    props: {
      selectedCompany: String,
      selectedCompanyInfo: Array,
      selectedCompanyId: Number,
      companyInvoiceItems: Array,
      companyInvoicesColor: String,
    },
    data: () => ({
      age: null,
      companyInvoicesGridHeaders: companyInvoicesGridHeaders,
      agingReportGridHeaders: agingReportGridHeaders,
      itemsPerPage: 15,
      showTotals: false,
    }),
    async created () {

    },
    methods: {
      companyInvoiceDetailsButtonClicked () {
        const g = this.$refs.companyInvoiceDetails
        if (this.toggleMaxArea(g)) {
          this.pieHeight = (window.innerHeight / 4) * 3
        } else {
          this.pieHeight = 800
        }
      },
      filterResults (originalData) {
        const combine = originalData.filter(item => {
          if (
            item.invoiceBalance > 0 &&
            ((item.within10days === true &&
              this.lateDays.includes('within10days')) ||
              (item.days31_60 > 0 &&
                this.lateDays.includes('days31_60')) ||
              (item.days61_90 > 0 &&
                this.lateDays.includes('days61_90')) ||
              (item.days91_120 > 0 &&
                this.lateDays.includes('days91_120')) ||
              (item.daysOver120 > 0 &&
                this.lateDays.includes('daysOver120')))
          ) {
            return true
          }
          return false
        })
        return combine.sort((a, b) => {
          if (a.companyName > b.companyName) return 1
          else if (a.companyName < b.companyName) return -1
          else return 0
        })
      },
      combineResults (originalData) {
        const merged = _.uniqWith(originalData, (pre, cur) => {
          if (pre.companyName === cur.companyName) {
            cur.invoiceAmount += pre.invoiceAmount
            cur.invoiceBalance += pre.invoiceBalance
            cur.days31_60 += pre.days31_60
            cur.days61_90 += pre.days61_90
            cur.days91_120 += pre.days91_120
            cur.daysOver120 += pre.daysOver120
            cur.numberOfInvoices += 1
            return true
          }
          return false
        })
        return merged
      },
      companyTotals (companyItems) {
        return [{
          within10days: this.sumField(companyItems, 'within10days'),
          days31_60: this.sumField(companyItems, 'days31_60'),
          days61_90: this.sumField(companyItems, 'days61_90'),
          days91_120: this.sumField(companyItems, 'days91_120'),
          daysOver120: this.sumField(companyItems, 'daysOver120'),
          invoiceAmount: this.sumField(companyItems, 'invoiceAmount'),
          invoiceBalance: this.sumField(companyItems, 'invoiceBalance'),
        }]
      },
      sumField (array, key) {
        // sum data in give key (property)
        return array.reduce((a, b) => a + (b[key] || 0), 0)
      },
      countField (array, key) {
        const trueItems = array.filter(item => {
          return item[key] === true
        })
        return trueItems.length
      },
      toggleMaxArea (section) {
        var fullSize = false
        var cl = section.$el.classList
        if (cl.contains('maxArea')) {
          cl.remove('maxArea')
        } else {
          fullSize = true
          cl.add('maxArea')
        }
        return fullSize
      },
      getTheme () {
        return this.$vuetify.theme.isDark ? 'dark' : 'light'
      },
      formatDate (d) {
        return formatDate(d)
      },
      formatNumber (number) {
        return formatNumber(number)
      },
      formatCurrency (currency) {
        return formatCurrency(currency)
      },
      formatPercentage (percentage) {
        return formatPercentage(percentage)
      },
      formatCurrencyBasic (currency) {
        return formatCurrencyBasic(currency)
      },
    },
  }
</script>

<style scoped>
.v-data-table::v-deep th {
  font-size: 12px !important;
}

.maxArea {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1000;

  width: 99%;
}

tr.v-data-table__selected {
  background-color: #1974d1 !important;
  color: white;
}
</style>
